export enum DocumentTypeEnum {
    Other = 0,
    ScienceArticle = 1,
    Patent = 2,
    Web = 3
}